import React from 'react';
import styles from './MiniNavbar.module.css';

const MiniNavbar = () => {
  return (
    <div className={styles.miniNavbar}>
      <div className={styles.left}> For Enquiry : 📞 +91-7200702908 | ✉️ info@bsparksoftwaretechnologies.com</div>
      {/* <div className={styles.right}>🚀 100% Placement Support for All Courses!</div> */}
    </div>
  );
};

export default MiniNavbar;
